function initGiftCardBannerPopups() {
	const sections = document.querySelectorAll('.gift-card-banner');

	sections.forEach((section) => {
		const popup = section.querySelector('.gift-card-banner__popup-wrapper');
		if (!popup) {
			return;
		}

		const closePopup = () => {
			popup.setAttribute('disabled', '');
		};

		const closeButtons = section.querySelectorAll('[data-gift-card-popup-close]');
		closeButtons.forEach((button) => {
			button.addEventListener('click', closePopup);
		});

		popup.addEventListener('click', (event) => {
			if (event.target === popup) {
				closePopup();
			}
		});
	});

	document.addEventListener('keydown', (event) => {
		if (event.key !== 'Escape') {
			return;
		}

		sections.forEach((section) => {
			const popup = section.querySelector('.gift-card-banner__popup-wrapper');
			if (popup && !popup.hasAttribute('disabled')) {
				popup.setAttribute('disabled', '');
			}
		});
	});
}

if (document.readyState === 'loading') {
	document.addEventListener('DOMContentLoaded', initGiftCardBannerPopups);
} else {
	initGiftCardBannerPopups();
}
